import cn from 'classnames/bind';
import React, { useCallback, useEffect, useState } from 'react';
import styles from './styles.styl';
import { useMediaQuery } from 'react-responsive';
import { Text } from '@consta/uikit/Text';
import { IconClose } from '@consta/uikit/IconClose';
import { Button } from '@consta/uikit/Button';
import { IconBackward } from '@consta/uikit/IconBackward';
import CenterLoader from '../CenterLoader';
import { IAllUsersDataEnt } from 'src/redux/features/users/allUsers/types';
import DragAccessModal from '../DragAccessModal';
import { useShallowEqualSelector } from 'src/customHooks/useShallowEqualSelector';
import { State } from 'src/redux/reducer';
import { userInitSelector } from 'src/redux/features/userInit/selectors';
import useRequest from 'src/customHooks/useRequest';
import userApi from 'src/utils/api/userApi';
import { AllModelType } from 'src/utils/type';
import { useDispatch } from 'react-redux';
import { editChangeUsersAdministration } from 'src/redux/features/administration/allUsersAdministration/actions';

const cx = cn.bind(styles);

export interface IAccessUserModalProps {
  setIsOpenModal: React.Dispatch<React.SetStateAction<boolean>>;
  infoUser: IAllUsersDataEnt;
  className?: string;
}

const AccessUserModal: React.FC<IAccessUserModalProps> = ({
  setIsOpenModal,
  infoUser,
  className,
}) => {
  const dispatch = useDispatch();

  const { userInit } = useShallowEqualSelector((state: State) => ({
    userInit: userInitSelector(state),
  }));

  const isMobile = useMediaQuery({ maxWidth: 460 });

  const [allModels, setAllModels] = useState<AllModelType[]>([]);
  const [availableModels, setAvailableModels] = useState<AllModelType[]>([]);

  // requests
  const { load: loadModelList, isLoading: isLoadingListModel } = useRequest(
    userApi.loadModelList,
    (data) => {
      if (data) {
        if (data?.linked_models?.length > 0) {
          setAvailableModels(data.linked_models);
        }
        if (data?.models?.length > 0) {
          setAllModels(data.models);
        }
      }
    },
  );

  const closeModal = useCallback(
    (data: IAllUsersDataEnt) => {
      setIsOpenModal(false);
      const newData = {
        id: data.id,
        user: data,
      };
      dispatch(editChangeUsersAdministration(newData));
    },
    [dispatch, setIsOpenModal],
  );

  const { load: loadEditModelList, isLoading } = useRequest(
    userApi.loadEditModelList,
    (data) => closeModal(data),
  );

  useEffect(() => {
    loadModelList(infoUser.id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [infoUser]);

  const vh = window.innerHeight * 0.01;

  document.documentElement.style.setProperty('--vh', `${vh}px`);

  const handleAccessModal = useCallback(() => {
    const newAvailableModels = availableModels.map((item) => item.id);
    loadEditModelList(infoUser.id, { models_ids: newAvailableModels });
  }, [availableModels, infoUser, loadEditModelList]);

  if (isLoadingListModel) return <CenterLoader />;
  return (
    <div className={cx('AccessUserModal', className)}>
      <div className={cx('AccessUserModal__fixedTitle')}>
        <div className={cx('AccessUserModal__title')}>
          {isMobile && (
            <Button
              className={cx('AccessUserModal__buttonCloseMobile')}
              iconSize="s"
              view="clear"
              onlyIcon
              iconLeft={IconBackward}
              onClick={() => setIsOpenModal(false)}
            />
          )}
          <Text className={cx('AccessUserModal__data')} weight="semibold">
            {'Доступные модели'}
          </Text>
          {!isMobile && (
            <Button
              className={cx('AccessUserModal__buttonClose')}
              iconSize="s"
              view="clear"
              onlyIcon
              iconLeft={IconClose}
              onClick={() => setIsOpenModal(false)}
            />
          )}
        </div>
      </div>
      <div className={cx('AccessUserModal__contentModal')}>
        <Text className={cx('AccessUserModal__fio')}>
          {infoUser.fio || '—'}
        </Text>
        <Text
          className={cx('AccessUserModal__username')}
          size="s"
          view="secondary"
        >
          {infoUser.username}
        </Text>
        <DragAccessModal
          userModelData={availableModels}
          setAvailableModels={setAvailableModels}
          allModels={allModels}
          setAllModels={setAllModels}
          userInit={userInit}
        />
      </div>
      <div className={cx('AccessUserModal__save')}>
        <Button
          label="Отменить"
          size="s"
          view="ghost"
          onClick={() => setIsOpenModal(false)}
          className={cx('AccessUserModal__buttonCancel')}
        />

        <Button
          onClick={handleAccessModal}
          size="s"
          label={'Сохранить'}
          className={cx('AccessUserModal__buttonSave')}
          loading={isLoading}
        />
      </div>
    </div>
  );
};

export default AccessUserModal;
